import { render, staticRenderFns } from "./Linux.vue?vue&type=template&id=a6ba94ec&scoped=true&"
import script from "./Linux.vue?vue&type=script&lang=js&"
export * from "./Linux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ba94ec",
  null
  
)

export default component.exports